module.exports = __webpack_public_path__ + "static/media/Austin Jephson.6f4d048c.png";